/* eslint-disable no-undef */
/* eslint-disable no-inner-declarations */
import { first } from 'lodash';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { KIDSMODE, screenDetailTypes } from '../../config/constants';
import { EVENT } from '../../contexts/MixpanelConstants';
import { MixpanelContext } from '../../contexts/MixpanelContext';
import f from '../../helpers/formatter';
import f2 from '../../helpers/formatter2';
import url from '../../helpers/url';
import user from '../../helpers/user';
import { IStore } from '../../interfaces/StoreTypes';
import { ClearDispatchedActions, LoadProfilesList } from '../../store/reducers/profileSlice';
import { __ } from '../../translations';
import { FlexWrapper, Text, Box, Avatar, Separator } from '@intigral/shared';
import withPresetWidth from '@intigral/shared/components/hocs/withPresetWidth/withPresetWidth';
import { getSelectedProfileAvatars } from '../../helpers/profile';
import useProfileAvatars from '../../hooks/useProfileAvatars';
import { useConfigurationSections } from '../../hooks/useConfiguration';

const BoxWidth = withPresetWidth(Box);

export const ProfileSettings = ({ profileList, ...props }) => {
    const { track }: { track: any } = useContext(MixpanelContext);
    // Using React Query instead of Redux for configuration
    const { kidsConfig, profile: profileConfig } = useConfigurationSections();
    const kidsHistoryEnable = kidsConfig?.kidsHistoryEnable;
    const profileColors = profileConfig?.colors;
    const { dispatchedActions } = useSelector((state: IStore) => state.profile);
    const { data: profileAvatars } = useProfileAvatars();
    const dispatch = useDispatch();
    const loadProfilesList = useCallback(() => dispatch(LoadProfilesList(false)), [dispatch]);
    const clearDispatchedActions = useCallback(() => dispatch(ClearDispatchedActions()), [dispatch]);
    const userProfiles = profileList?.profiles ?? [];
    const [eligibleToAdd, setEligibleToAdd] = useState(false);

    useEffect(() => {
        if (userProfiles) {
            setEligibleToAdd(userProfiles?.length < profileList?.profilesLimit);
        } else {
            loadProfilesList();
        }
    }, [userProfiles]);

    useEffect(() => {
        if (dispatchedActions && dispatchedActions.action) {
            setTimeout(() => {
                clearDispatchedActions();
            }, 2500);
        }
    }, []);
    return (
        <>
            {dispatchedActions?.action &&
                dispatchedActions?.action !== 'hasBeenDeleted' &&
                typeof dispatchedActions?.message === 'object' && (
                    <div className="profile-form_notification">
                        <span className="profile-form_notiTitle">
                            {__(`manage_profile_${dispatchedActions?.action}_successfully`).replace(
                                '{profile Name}',
                                dispatchedActions?.message?.profileName
                            )}
                        </span>
                    </div>
                )}

            {/* <Text as="h1" variant="h1" alignment="start" className="profile-settings-header">
                {__('profile_settings')}
            </Text> */}

            <div className="container">
                <BoxWidth theme="light" padding={{ default: '2x', md: '6x' }} presetWidth="xlarge">
                    <FlexWrapper
                        flexDirection="row"
                        justifyContent="between"
                        alignItems="center"
                        marginBottom={{ default: '4x' }}
                    >
                        <Text as="h2" variant="h2" alignment="start" margin="0" fontWeight="medium">
                            {__('manage_profile_list_title')}
                        </Text>
                        {eligibleToAdd && (
                            <Text as="span" size="14">
                                <Link
                                    to={url.route('add-profile')}
                                    state={{ fromRoute: url.getDetailsPage(screenDetailTypes.PROFILE_SETTINGS) }}
                                    className="primary-brand"
                                >
                                    {__('add_profiles')}
                                </Link>
                            </Text>
                        )}
                    </FlexWrapper>

                    {(userProfiles &&
                        userProfiles.length &&
                        userProfiles.map((profile, index) => {
                            return (
                                <>
                                    <FlexWrapper
                                        flexDirection="row"
                                        justifyContent="between"
                                        alignItems="center"
                                        key={profile.profileGuid}
                                    >
                                        <Avatar
                                            variant="inline"
                                            image={getSelectedProfileAvatars(profile, profileAvatars)}
                                            //color={profile.kidsMode ? profile?.avatar : profile?.avatar}
                                            currentRestriction={__(
                                                'parentalControl_' +
                                                    (profile.newParentalControl || profile.parentalControl)
                                            )}
                                            name={profile?.profileName}
                                            dimension="small"
                                            {...(profile.passwordProtected && { locked: true })}
                                        />
                                        <FlexWrapper
                                            flexDirection="row"
                                            justifyContent="end"
                                            alignItems="center"
                                            gap="2x"
                                        >
                                            {kidsHistoryEnable &&
                                                user.getProfileMode() === KIDSMODE.PARENT &&
                                                profile.kidsMode && (
                                                    <Text as="span" size="14">
                                                        <Link
                                                            onClick={() =>
                                                                track(`${EVENT.PROFILE_SETTINGS.HISTORY_CLICK}`, {
                                                                    selectedProfileName: profile?.profileName,
                                                                })
                                                            }
                                                            to={url.route('profile-history', {
                                                                profile: btoa(profile?.profileName),
                                                            })}
                                                            className="primary-brand"
                                                        >
                                                            {__('history')}
                                                        </Link>
                                                    </Text>
                                                )}
                                            <Text as="span" size="14">
                                                <Link
                                                    to={url.route('edit-profile', { guid: btoa(profile.profileGuid) })}
                                                    state={{
                                                        fromRoute: url.getDetailsPage(
                                                            screenDetailTypes.PROFILE_SETTINGS
                                                        ),
                                                    }}
                                                    className="primary-brand"
                                                >
                                                    {__('manage_profile_list_profiles_edit')}
                                                </Link>
                                            </Text>
                                        </FlexWrapper>
                                    </FlexWrapper>
                                    {index !== userProfiles.length - 1 && <Separator color="light" key={index} />}
                                </>
                            );
                        })) || <></>}
                </BoxWidth>
            </div>
        </>
    );
};
